import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalIncomeCallPop } from "../popup/IncomeCallPop";

const Driving = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(item) {
      await handleMasterSearch(item);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [callCount, setCallCount] = useState({
    statusD: "",
    statusT: "",
  });

  const {
    store: { userInfo, tabSize },
  } = useAppContext();

  const SEARCH_DRIVING_VEHICLE_LIST_URL =
    "/mobileweb/driving/SP_SEARCH_DRIVING_VEHICLE_LIST.do";

  //운송중-운송대기 카운트 호출
  const SEARCH_DRIVING_VEHICLE_COUNT_URL =
    "/mobileweb/driving/SP_SEARCH_DRIVING_VEHICLE_COUNT.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_DRIVING_VEHICLE_LIST_URL,
    },
    { manual: true }
  );

  useEffect(async () => {
    handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (item) => {
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_DRIVING_VEHICLE_LIST_URL,
      params: item,
    });
    //console.log(data);
    setSearchData(data);

    const count = await fetchData({
      url: SEARCH_DRIVING_VEHICLE_COUNT_URL,
      params: item,
    });
    //console.log(count.data.data[0]);

    setCallCount(count.data.data[0]);
  };

  return (
    <>
      <div id="menu4" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index}>
                <div className="ctitle">
                  <h1 className="carno">{data.vhclNo}</h1>
                  <div>
                    {data.warmCnt > 0 ? <button className="al"></button> : ""}
                    {data.outageWght > 0 ? (
                      <div className="nums">-{data.outageWght}</div>
                    ) : (
                      ""
                    )}
                    {data.returnCnt > 0 ? (
                      <button className="close"></button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="ctitle">
                  <h2>
                    {data.itemNm}
                    {data.itemEtcRmksNm !== " " ? "/" + data.itemEtcRmksNm : ""}
                    {data.inspRmks !== " " ? "(" + data.inspRmks + ")" : ""}
                  </h2>
                  <div>
                    <div className="stat ready">배차</div>
                    <div className="no">
                      <h2 className="ready">{data.tmsOdrNo}</h2>
                    </div>
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>
                      {props.bmenuTab === "scrap"
                        ? data.loadAreaAddr
                        : data.shipNm}
                    </h2>
                  </div>
                  <div className="phone">
                    <h2>{data.drivTel}</h2>
                  </div>
                  <div>
                    <div className="stat arrive">예정</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.arrvDt}
                      </h2>
                    </div>
                  </div>
                  <div className="com">
                    <h2>
                      {data.vndrNm} / {data.rvndrNm}
                    </h2>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>운송중</div>
            <div className="val">
              <div>{callCount.statusD}</div>
            </div>
          </div>
          <div>
            <div>운송대기</div>
            <div className="val">
              <div>{callCount.statusT}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default Driving;
